<canvas #canvasEl [class.hidden]="!enabled"></canvas>
<app-loading-indicator color="white" class="image-loading-indicator" size="small" *ngIf="loading">
</app-loading-indicator>
